import { render, staticRenderFns } from "./AlertTip.vue?vue&type=template&id=36dde72a&scoped=true&"
import script from "./AlertTip.vue?vue&type=script&lang=js&"
export * from "./AlertTip.vue?vue&type=script&lang=js&"
import style0 from "./AlertTip.vue?vue&type=style&index=0&id=36dde72a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dde72a",
  null
  
)

export default component.exports